export enum FrameType {
  ACK = "ack",
  ERROR = "error",
  BRACKET = "bracket",
  TEXT = "text",
}

export enum EIDOutputFormat {
  WITH_SPACE = "0",
  NO_SPACE = "1",
  HEX = "2",
  ISO = "3",
  ISO_23 = "4",
}

interface FrameBase {
  raw: string;
}

export interface ScpAckFrame extends FrameBase {
  type: FrameType.ACK;
}

export interface ScpErrorFrame extends FrameBase {
  type: FrameType.ERROR;
  code: string;
}

export interface ScpBracketFrame extends FrameBase {
  type: FrameType.BRACKET;
  value: string | null;
}

export interface ScpTextFrame extends FrameBase {
  type: FrameType.TEXT;
  value: string;
}

export type ScpFrame =
  | ScpAckFrame
  | ScpErrorFrame
  | ScpBracketFrame
  | ScpTextFrame;
